export default {
  getAdsets: state => state.adsets,
  getSelectedAdset: state => state.selectedAdset
}
